import { render, staticRenderFns } from "./userGroupAudit.vue?vue&type=template&id=5d944c8f&"
import script from "./userGroupAudit.vue?vue&type=script&lang=js&"
export * from "./userGroupAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d944c8f')) {
      api.createRecord('5d944c8f', component.options)
    } else {
      api.reload('5d944c8f', component.options)
    }
    module.hot.accept("./userGroupAudit.vue?vue&type=template&id=5d944c8f&", function () {
      api.rerender('5d944c8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/auditManage/userGroupAudit/userGroupAudit.vue"
export default component.exports